import { render, staticRenderFns } from "./TransferRequestApprovalDialog.vue?vue&type=template&id=92c2903a&scoped=true&"
import script from "./TransferRequestApprovalDialog.vue?vue&type=script&lang=js&"
export * from "./TransferRequestApprovalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c2903a",
  null
  
)

export default component.exports